module.exports = __webpack_public_path__ + "static/transposh3-992cd681555b43e226e9cdbee0e25da9.jpg";